import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleCheck,
  faCircleExclamation,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons';
import { useMemo } from 'react';

import { useLimitColorFeedback } from './useLimitColorFeedback';

interface IStatusIconResult {
  icon: IconProp;
  iconColor: string;
}

export function useStatusIcon(used: number, limit: number): IStatusIconResult {
  const { progressTheme } = useLimitColorFeedback(used, limit);

  return useMemo(() => {
    let icon: IconProp;
    let iconColor: string;

    switch (progressTheme) {
      case 'red':
        icon = faCircleExclamation;
        iconColor = 'var(--color-red-600)';
        break;

      case 'yellow':
        icon = faTriangleExclamation;
        iconColor = 'var(--color-yellow-600)';
        break;

      default:
        icon = faCircleCheck;
        iconColor = 'var(--color-green-600)';
        break;
    }

    return { icon, iconColor };
  }, [progressTheme]);
}
